import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { SummaryService } from '../../../summary/service/summary.service';
import { PDFViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { CheckBoxChangeEventArgs } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'ocado-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrl: './common-dialog.component.scss',
  standalone: true,
  imports: [DialogModule, ButtonModule, PDFViewerComponent, CheckBoxModule, NgClass],
})

export class CommonDialogComponent {

  constructor(private summaryService: SummaryService) { }

  @Input() title!: string;
  @Input() message1!: string;
  @Input() message2!: string;
  @Input() message3!: string;
  @Input() actionBtn!: string;
  @Input() cancelBtn!: string;
  @Input() hasGap!: boolean;
  @Output() actionBtnEvent = new EventEmitter();
  @Output() cancelBtnEvent = new EventEmitter();
  @Output() checkBoxChangeEvent = new EventEmitter();
  pdfBase64Url: string = "";
  isOpenPdf: boolean = false;

  openPDF() {
    this.summaryService.fetchTermsConditionPdf().subscribe((data) => {
      this.isOpenPdf = true;
      this.pdfBase64Url = `data:application/pdf;base64,${data.result}`;
    });
  }

  pdfClosed() {
    this.isOpenPdf = false;
  }

  resumeEdit(args: boolean) {
    this.cancelBtnEvent.emit(args);
  }
  actionEmit() {
    this.actionBtnEvent.emit();
  }

  checkBoxChange(args: CheckBoxChangeEventArgs) {
    this.checkBoxChangeEvent.emit(args.checked);
  }
}
